export function formatDuration(totalSeconds) {
  const abs = Math.abs(totalSeconds);
  const mm = Math.floor(abs / 60).toString().padStart(2, '0');
  const ss = (abs % 60).toString().padStart(2, '0');
  return `${mm}:${ss}`;
}

export function getDefaultDuration(config) {
  return Number(config?.bakingDurationSeconds ?? 90);
}

export function getOrderDuration(order, config) {
  return Number(order?.bakingDuration ?? getDefaultDuration(config));
}

export function getRemainingSeconds(order, now, defaultDuration) {
  if (!order || typeof now !== 'number') {
    return null;
  }

  const startedAt = order.bakingStartedAt
    ? new Date(order.bakingStartedAt).getTime()
    : new Date(order.updatedAt || order.createdAt).getTime();
  if (!Number.isFinite(startedAt)) {
    return null;
  }

  const duration = Number(order.bakingDuration ?? defaultDuration);
  return duration - Math.floor((now - startedAt) / 1000);
}

export function isOvertime(remaining) {
  return remaining !== null && remaining < 0;
}

export function getBakingProgress(order, remaining, defaultDuration) {
  if (!order) {
    return 0;
  }
  const duration = Number(order.bakingDuration ?? defaultDuration);
  return Math.min(1, Math.max(0, (duration - remaining) / duration));
}

export function getBakingTimerLabel(order, remaining, defaultDuration, t) {
  if (!order || order.state !== 'baking' || remaining === null) {
    return null;
  }

  if (remaining < 0) {
    return t('banner.timerOvertime', { time: formatDuration(remaining) });
  }

  const duration = Number(order.bakingDuration ?? defaultDuration);
  return t('banner.timerElapsed', {
    elapsed: formatDuration(duration - remaining),
    remaining: formatDuration(remaining),
  });
}